import { AppMetaTempGlobals } from "@crispico/foundation-react/AppMetaTempGlobals";
import { entityDescriptors } from "@crispico/foundation-react/entity_crud/entityCrudConstants";
import { IGanttActionParam, IGanttActionParamForRun } from "@crispico/react-timeline-10000";
import { IActionParam } from "@crispico/react-timeline-10000/types/components/ContextMenu/IAction";
import { AbstractAction, AbstractActionLocalState, AbstractActionProps } from "components/ContextMenuRegistry";
import moment from "moment-timezone";
import { EntityTablePageWithGanttState } from "pages/gantt/components/tables/EntityTablePageWithGantt";
import { MissionStatus } from "pages/gantt/typeRenderers/constants";
import { Mission } from "types";

export const OVERDUE_MINUTES = 30;

export class OpenClosedAndOverdueMissions extends AbstractAction<AbstractActionProps, AbstractActionLocalState> {
    icon = "tasks";
    label = (param: IActionParam) => {
        const entityName = this.getEntityName(param.selection[0]);
        if (entityName && entityName === "Mission2") {
            return _msg("OpenClosedAndOverdueMission.label");
        }
        return _msg("OpenClosedAndOverdueMissions.label");
    }

    isVisible(param: IGanttActionParam) {
        if (param.selection.length !== 1) {
            return false;
        }
        const entityName = this.getEntityName(param.selection[0]);
        if (entityName === "Mission2") {
            // visible only on closed mission or not closed mission and overdue 30min
            const entity = this.props.getEntityAt(param.selection[0]) as Mission;
            if (entity && entity.status != MissionStatus.MISSION_STATUS_FINISHED && moment(entity.endTime).valueOf() > moment().add(-OVERDUE_MINUTES, 'minutes').valueOf()) {
                return false;
            }
        }
        return entityName === "EquipmentResource" || entityName === "HumanResourceSchedule" || entityName === "Mission2";
    }

    private getSearchParams(param: IGanttActionParamForRun) {
        const entityName = this.getEntityName(param.selection[0]);
        const entity = this.props.getEntityAt(param.selection[0])!;
        if (!entity) {
            return '';
        }
        const filters = [];
        // date from gantt or today
        const date = (this.props.tablePage.props.s as unknown as EntityTablePageWithGanttState).options?.date ?? new Date().toISOString();
        filters.push(
            { "$F": "startTime", "$O": "dayOf", "$V": date },
            {
                "$O": "or", "$FS": [
                    { "$F": "status", "$O": "equals", "$V": MissionStatus.MISSION_STATUS_FINISHED },
                    {
                        "$O": "and", "$FS": [
                            { "$F": "status", "$O": "notEquals", "$V": MissionStatus.MISSION_STATUS_FINISHED },
                            { "$F": "endTime", "$O": "lessThanOrEqualTo", "$V": new Date(moment().add(-OVERDUE_MINUTES, 'minutes').valueOf()).toISOString() }
                        ]
                    }
                ]
            });
        switch (entityName) {
            case "Mission2":
                filters.push({ "$F": "id", "$O": "equals", "$V": entity.id });
                break;
            case "EquipmentResource":
                filters.push({ "$F": "equipmentResource.id", "$O": "equals", "$V": entity.id });
                break;
            case "HumanResourceSchedule":
                filters.push({ "$F": "humanResource.id", "$O": "equals", "$V": entity.humanResource.id });
                break;
        }
        const params = new URLSearchParams();
        params.set(`cqs`, JSON.stringify([{ "$F": "endTime", "$D": "DESC" }]));
        params.set(`cqf`, JSON.stringify({ "$O": "and", "$FS": filters }));
        params.set(`goToEditIfSingleEntity`, "true");

        return params.toString();
    }

    async run(param: IGanttActionParamForRun) {
        const searchParams = this.getSearchParams(param);
        AppMetaTempGlobals.history.push(entityDescriptors["Mission2"].getEntityTableUrl() + "?" + searchParams);
    }
}
